import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { DividendReInvestSettings } from '../entities/dividend-re-invest-settings.entity';

@Injectable({
  providedIn: 'root',
})
export class DividendReInvestInfrastructure {
  readonly #http = inject(HttpClient);
  readonly #api = `${environment.apihost}/api/user/dividend-reinvest`;

  public decline = () => this.#post({ doReinvest: false });
  public activate = (amountFrom: number) => this.#post({ doReinvest: true, amountFrom });
  public loadSettings = () => this.#http.get<DividendReInvestSettings>(`${this.#api}`);

  #post = (payload: DividendReInvestSettings) => this.#http.post<DividendReInvestSettings>(`${this.#api}`, payload);
}
